import React from 'react';

import {useBreakpoint} from '@udemy/hooks';
import {
    DesktopInstructorHeader,
    DesktopInstructorHeaderProps,
    MobileInstructorHeader,
} from '@udemy/react-header';

import styles from './instructor-header.module.less';

export type InstructorHeaderProps = DesktopInstructorHeaderProps;

export const InstructorHeader = (props: InstructorHeaderProps) => {
    const breakpoint = useBreakpoint({
        mobile: 800,
        desktop: 9999,
    });

    return (
        <>
            {breakpoint !== 'desktop' && (
                <div className={styles['mobile-only']}>
                    <MobileInstructorHeader isInsideDesktopHeader={false} {...props} />
                </div>
            )}
            {breakpoint !== 'mobile' && (
                <div className={styles['desktop-only']}>
                    <DesktopInstructorHeader {...props} />
                </div>
            )}
        </>
    );
};
